import Vue from 'vue';

import forEach from 'lodash/forEach';

import newVueChart from '@/helpers/newChart';
import help_rest from '@/helpers/rest';

export default {
	...help_rest,
	onMove(evt) {
		console.log(evt);
		if (evt.dragged && evt.dragged.classList.contains('fixed')){
	        return false;
	    }
		if (evt.related){
	        return !evt.related.classList.contains('fixed');
	    }
	},
	waitForCharts(){
		var self = this;
		return new Promise(resolve => {
			let interval = window.setInterval(function(){
				if(!self.$store.getters.chartemplates_loading && self.$store.getters.chartemplates){
					clearInterval(interval);
					resolve(self.$store.getters.chartemplates);
				}
			}, 100);
		});
	},
	setupChart(item){
		let self = this;

		const chartname = 'v-chart-' + item.template.toLowerCase(),
			  charttemplates = this.$store.getters.chartemplates,
			  chartcomponents = this.$store.getters.chartcomponents;

		window.preloadedimages = window.preloadedimages || [];
		forEach(item.addablecharts, (aachart, key) => {
			if(aachart.image.indexOf(window.preloadedimages)){
				if(self.$store.getters.devmode) console.debug('PRELOAD', aachart.image);

				window.preloadedimages.push(aachart.image);
				new Image().src = aachart.image;
			}
		});

		if(chartcomponents.indexOf(chartname) >= 0) {
			return false;
		}


		let chart = newVueChart();

		if(charttemplates[chartname]) {
			chart.template = charttemplates[chartname];
			Vue.component(chartname, chart);
			this.$store.commit('ADD_CHARTCOMPONENTS', chartname);
		} else {
			console.error('missing template for ' + chartname, charttemplates);
		}

		if(item.charts){
			Object.keys(item.charts)
			.forEach(function(k){
				self.setupChart(item.charts[k]);
			});
		}
	},

	flatenCharts(charts){
		const self = this;
		let out = {};
		Object.keys(charts).forEach(function(key){
			let chart = charts[key]
			if(!out[chart.id]) Vue.set(out, chart.id, chart);
			if(chart.charts) out = Object.assign({}, out, self.flatenCharts(chart.charts));
		});

		return out;
	},

	chartTemplatesHasMissingTemplate(templates, charts){
		let chs = this.flatenCharts(charts),
			missingTemplate = false;

		forEach(chs, (ch, keyid) => {
			if(typeof templates['v-chart-' + ch.component] === 'undefined') missingTemplate = true;
		});

		return missingTemplate;
	},

	getChartTemplates(){
		var self = this;
		return new Promise((resolve, reject) => {
			console.log('chartTemplatesHasMissingTemplate:',self.chartTemplatesHasMissingTemplate(self.$store.getters.chartemplates, self.$store.getters.charts));
			if(self.$store.getters.chartemplates && !self.chartTemplatesHasMissingTemplate(self.$store.getters.chartemplates, self.$store.getters.charts)){
				resolve(self.$store.getters.chartemplates);
			} else if(self.$store.getters.chartemplates_loading) {
				resolve(this.waitForCharts());
			} else {
				self.$store.commit('START_LOADING_CHARTTEMPLATES');
				this.restget(self.$store.getters.channel.urls.charttemplates, 'charttemplates')
					.then(function (message) {
						self.$store.commit('SET_CHARTTEMPLATES', message);
						self.$store.commit('STOP_LOADING_CHARTTEMPLATES');
						resolve(message);
					})
					.catch(function (error) {
						self.$store.commit('ADD_ERROR', error);
						reject(error);
					});
			}
		});
	}
};



// WEBPACK FOOTER //
// ./src/helpers/chart.js